<div class="container">
  <form [formGroup]="stepOneForm">
    <div class="form-group">
      <div class="row">
        <div class="col-12 col-md-6 mb-3 mt-2">
          <label class="form-check-label" for="system_name" style="font-weight: bold;">
            {{"SYSTEM.STEPONE.SYSTEMNAME" | translate}}<sup class="small-asterisk">*</sup>
            <mat-icon class="ms-2"
              matTooltip="{{'SYSTEM.STEPONE.NAMETOOLTIP' | translate}}"
              style="font-size: medium;" fontIcon="info"></mat-icon>
          </label>
          <input type="text" name="system_name" id="system_name" class="form-control" formControlName="system_name"
            placeholder="{{'SYSTEM.STEPONE.SYSTEMPLACEHOLDER' | translate}}"
            [class.is-invalid]="stepOneForm.get('system_name')?.invalid && (stepOneForm.get('system_name')?.dirty || submitted)">
          <div class="text-danger mt-1" *ngIf="stepOneForm.get('system_name')?.invalid && (stepOneForm.get('system_name')?.dirty || submitted)" style="font-size: small;">{{"SYSTEM.STEPONE.INSERTNAME" | translate}}</div>
        </div>

        <div class="col-12 mb-3 mt-2">
          <label for="system_description" style="font-weight: bold;">
            {{"SYSTEM.STEPONE.SHORTDESCRIPTION" | translate}}
            <mat-icon class="ms-2" matTooltip="{{'SYSTEM.STEPONE.DESCTOOLTIP' | translate}}" fontIcon="info"
              style="font-size: medium;"></mat-icon>
          </label>
          <textarea type="text" name="system_description" id="system_description" formControlName="system_description"
            class="form-control" placeholder="{{'SYSTEM.STEPONE.SHORTINFO' | translate}}"></textarea>
        </div>

        <div class="col-12 ms-3 mb-3 mt-2 form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="system_owner" formControlName="system_owner"
            [checked]="stepOneForm.get('system_owner')?.value === 1" (change)="onCheckboxChange($event)">
          <label class="form-check-label" for="system_owner" style="font-weight: bold;">
            {{"SYSTEM.STEPONE.OWNER" | translate}}</label>
        </div>

        <ng-template [ngIf]="stepOneForm.get('system_owner')?.value === 0">
          <div class="col-12 col-lg-6 mb-3 mt-2">
            <label for="customer_name" style="font-weight: bold;">{{"SYSTEM.STEPONE.NAME" | translate}}
              <sup class="small-asterisk">*</sup></label>
            <input type="text" name="customer_name" id="customer_name" formControlName="customer_name"
              class="form-control" placeholder='{{"SYSTEM.STEPONE.NAMEPLACEHOLDER" | translate}}'
              [class.is-invalid]="stepOneForm.get('customer_name')?.invalid && (stepOneForm.get('customer_name')?.dirty || submitted)">
              <div class="text-danger mt-1" *ngIf="stepOneForm.get('system_name')?.invalid && (stepOneForm.get('customer_name')?.dirty || submitted)" style="font-size: small;">{{"SYSTEM.STEPONE.NAMEERROR" | translate}}</div>
          </div>
          <div class="col-12 col-lg-6 mb-3 mt-2">
            <label for="customer_surname" style="font-weight: bold;">{{"SYSTEM.STEPONE.SURNAME" | translate}}<sup
                class="small-asterisk">*</sup></label>
            <input type="text" name="customer_surname" id="customer_surname" formControlName="customer_surname"
              class="form-control" placeholder='{{"SYSTEM.STEPONE.SURNAMEPLACEHOLDER" | translate}}'
              [class.is-invalid]="stepOneForm.get('customer_surname')?.invalid && (stepOneForm.get('customer_surname')?.dirty || submitted)">
              <div class="text-danger mt-1" *ngIf="stepOneForm.get('system_name')?.invalid && (stepOneForm.get('customer_surname')?.dirty || submitted)" style="font-size: small;">{{"SYSTEM.STEPONE.SURNAMEERROR" | translate}}</div>
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <label for="customer_country" style="font-weight: bold;">{{"SYSTEM.STEPONE.COUNTRY" | translate}}
              <sup class="small-asterisk">*</sup></label>
            <select class="form-select" aria-label="select example" formControlName="customer_country"
            [class.is-invalid]="stepOneForm.get('customer_country')?.invalid && (stepOneForm.get('customer_country')?.dirty || submitted)">
              <option [ngValue]="null" disabled>{{"SYSTEM.STEPONE.SELECTCOUNTRY" | translate}}</option>
              <option *ngFor="let country of countriesData" [ngValue]="country.id">
                 {{ country.common_name }}
              </option>
            </select>
            <div class="text-danger mt-1" *ngIf="stepOneForm.get('system_name')?.invalid && (stepOneForm.get('customer_country')?.dirty || submitted)" style="font-size: small;">{{"SYSTEM.STEPONE.SELECTCOUNTRY" | translate}}</div>
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <label for="customer_phone" style="font-weight: bold;">{{"SYSTEM.STEPONE.PHONE" | translate}}<sup
                class="small-asterisk">*</sup></label>
            <input type="customer_phone" name="customer_phone" id="customer_phone" formControlName="customer_phone"
              class="form-control" placeholder='{{"SYSTEM.STEPONE.PHONEPLACEHOLDER" | translate}}'
              [class.is-invalid]="stepOneForm.get('customer_phone')?.invalid && (stepOneForm.get('customer_phone')?.dirty || submitted)">
            <div class="text-danger mt-1" *ngIf="stepOneForm.get('system_name')?.invalid && (stepOneForm.get('customer_phone')?.dirty || submitted)" style="font-size: small;">{{"SYSTEM.STEPONE.PHONEERROR" | translate}}</div>
          </div>
          <div class="col-12 col-lg-6 mb-3" *ngIf="stepOneForm.get('customer_country')?.value == 12">
            <label for="customer_vat" style="font-weight: bold;">{{"SYSTEM.STEPONE.VAT" | translate}}</label>
            <input type="text" name="customer_vat" id="customer_vat" formControlName="customer_vat" class="form-control"
              placeholder="">
          </div>
          <div class="col-12 col-lg-6 mb-3" *ngIf="stepOneForm.get('customer_country')?.value != 12">
            <label for="customer_licensenumber" style="font-weight: bold;">{{"SYSTEM.STEPONE.LICENSENUMBER" |
              translate}}<sup class="small-asterisk">*</sup>
            <mat-icon class="ms-2"
            matTooltip="{{'SYSTEM.STEPONE.LICENSENUMBERTOOLTIP' | translate}}"
            style="font-size: medium;" fontIcon="info"></mat-icon>
            </label>
            <input type="text" name="customer_licensenumber" id="customer_licensenumber"
              formControlName="customer_licensenumber" class="form-control"
              [class.is-invalid]="stepOneForm.get('customer_licensenumber')?.invalid && (stepOneForm.get('customer_licensenumber')?.dirty || submitted)">
              <div class="text-danger mt-1" *ngIf="stepOneForm.get('system_name')?.invalid && (stepOneForm.get('customer_licensenumber')?.dirty || submitted)" style="font-size: small;">{{"SYSTEM.STEPONE.LICENSEERROR" | translate}}</div>
          </div>
          <div class="col-12 col-lg-6 mb-3" *ngIf="stepOneForm.get('customer_country')?.value == 12">
            <label for="customer_fiscalcode" style="font-weight: bold;">{{"SYSTEM.STEPONE.FISCALCODE" | translate}}<sup
                class="small-asterisk">*</sup></label>
            <input type="text" name="customer_fiscalcode" id="customer_fiscalcode" formControlName="customer_fiscalcode"
              class="form-control" [class.is-invalid]="stepOneForm.get('customer_fiscalcode')?.invalid && (stepOneForm.get('customer_fiscalcode')?.dirty || submitted)">
              <div class="text-danger mt-1" *ngIf="stepOneForm.get('system_name')?.invalid && (stepOneForm.get('customer_fiscalcode')?.dirty || submitted)" style="font-size: small;">{{"SYSTEM.STEPONE.FISCALCODEERROR" | translate}}</div>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput placeholder="Last name, First name" formControlName="firstCtrl" required>
        </mat-form-field> -->
    <div class="row justify-content-center">
      <div *ngIf="!isReadonly; else updateBlock" class="col-12 text-center px-0">
        <button class="btn btn-outline-dark me-2" id="next" (click)="saveStep('save')">
          {{"SYSTEM.STEPBUTTONS.SAVE" | translate}}
        </button>
        <button class="btn btn-outline-dark ms-2" id="next" (click)="saveStep('next')" *ngIf="idsystem > 0">
          {{"SYSTEM.STEPBUTTONS.NEXT" | translate}}
        </button>
      </div>
      <ng-template #updateBlock>
        <div class="col-12 text-center">
          <button class="btn btn-outline-dark" (click)="approvalRequested()">
            {{"SYSTEM.STEPBUTTONS.UPDATE" | translate}}
          </button>
        </div>
      </ng-template>
    </div>
  </form>
</div>
